// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AppRouteRouteImport } from './routes/_app/route'
import { Route as LandingRouteRouteImport } from './routes/_landing/route'
import { Route as AppAccountRouteImport } from './routes/_app/account'
import { Route as AppCheckoutRouteImport } from './routes/_app/checkout'
import { Route as AppDevResourcesRouteImport } from './routes/_app/dev-resources'
import { Route as AppEmployeesRouteImport } from './routes/_app/employees'
import { Route as AppJobsRouteImport } from './routes/_app/jobs'
import { Route as AppMarketRouteImport } from './routes/_app/market'
import { Route as AppOffersRouteImport } from './routes/_app/offers'
import { Route as AppOrgsRouteImport } from './routes/_app/orgs'
import { Route as AppReportRouteImport } from './routes/_app/report'
import { Route as AppTeamsRouteImport } from './routes/_app/teams'
import { Route as LandingCookiesPolicyRouteImport } from './routes/_landing/cookies-policy'
import { Route as LandingDocsRouteImport } from './routes/_landing/docs'
import { Route as LandingPrivacyPolicyRouteImport } from './routes/_landing/privacy-policy'
import { Route as LandingTermsOfUseRouteImport } from './routes/_landing/terms-of-use'
import { Route as AppPublicBeginPasswordResetRouteImport } from './routes/_app/_public.begin-password-reset'
import { Route as AppPublicLoginRouteImport } from './routes/_app/_public.login'
import { Route as AppAccountIndexRouteImport } from './routes/_app/account.index'
import { Route as AppAccountApiRouteImport } from './routes/_app/account.api'
import { Route as AppAccountBillingRouteImport } from './routes/_app/account.billing'
import { Route as AppBetaGenerateRouteImport } from './routes/_app/beta.generate'
import { Route as AppDevResourcesIndexRouteImport } from './routes/_app/dev-resources.index'
import { Route as AppDevResourcesComponentsRouteImport } from './routes/_app/dev-resources.components'
import { Route as AppDevResourcesEmailsRouteImport } from './routes/_app/dev-resources.emails'
import { Route as AppDevResourcesErrorsRouteImport } from './routes/_app/dev-resources.errors'
import { Route as AppDevResourcesTransitionsRouteImport } from './routes/_app/dev-resources.transitions'
import { Route as AppEmployeesListRouteImport } from './routes/_app/employees._list'
import { Route as AppJobsListRouteImport } from './routes/_app/jobs._list'
import { Route as AppMarketReportRouteImport } from './routes/_app/market._report'
import { Route as AppOffersListRouteImport } from './routes/_app/offers._list'
import { Route as AppOrgsIndexRouteImport } from './routes/_app/orgs.index'
import { Route as AppRegisterIndexRouteImport } from './routes/_app/register.index'
import { Route as AppRegisterApplicantRouteImport } from './routes/_app/register.applicant'
import { Route as AppRegisterCompanyRouteImport } from './routes/_app/register.company'
import { Route as AppReportReportRouteImport } from './routes/_app/report._report'
import { Route as AppTeamsIndexRouteImport } from './routes/_app/teams.index'
import { Route as AppTeamsTeamIdRouteImport } from './routes/_app/teams.$teamId'
import { Route as AppTestIndexRouteImport } from './routes/_app/test.index'
import { Route as AppTestCompetencesRouteImport } from './routes/_app/test.competences'
import { Route as AppTestPersonalityRouteImport } from './routes/_app/test.personality'
import { Route as AppTestValuesRouteImport } from './routes/_app/test.values'
import { Route as AppPublicEmployeeInvitationTokenRouteImport } from './routes/_app/_public.employee-invitation.$token'
import { Route as AppPublicUpdatePasswordTokenRouteImport } from './routes/_app/_public.update-password.$token'
import { Route as AppPublicVerifyEmailTokenRouteImport } from './routes/_app/_public.verify-email.$token'
import { Route as AppAccountApiIndexRouteImport } from './routes/_app/account.api.index'
import { Route as AppAccountApiAppIdRouteImport } from './routes/_app/account.api.$appId'
import { Route as AppDevResourcesTransitionsIndexRouteImport } from './routes/_app/dev-resources.transitions.index'
import { Route as AppDevResourcesTransitionsOneRouteImport } from './routes/_app/dev-resources.transitions.one'
import { Route as AppDevResourcesTransitionsTwoRouteImport } from './routes/_app/dev-resources.transitions.two'
import { Route as AppEmployeesListIndexRouteImport } from './routes/_app/employees._list.index'
import { Route as AppEmployeesListEmployeeIdRouteImport } from './routes/_app/employees._list.$employeeId'
import { Route as AppJobsListIndexRouteImport } from './routes/_app/jobs._list.index'
import { Route as AppJobsListJobIdRouteImport } from './routes/_app/jobs._list.$jobId'
import { Route as AppMarketReportIndexRouteImport } from './routes/_app/market._report.index'
import { Route as AppOffersListIndexRouteImport } from './routes/_app/offers._list.index'
import { Route as AppOffersListOfferIdRouteImport } from './routes/_app/offers._list.$offerId'
import { Route as AppOrgsOrgIdIndexRouteImport } from './routes/_app/orgs.$orgId.index'
import { Route as AppReportReportIndexRouteImport } from './routes/_app/report._report.index'
import { Route as AppTeamsTeamIdIndexRouteImport } from './routes/_app/teams.$teamId.index'
import { Route as AppTeamsTeamIdBoardRouteImport } from './routes/_app/teams.$teamId.board'
import { Route as AppTeamsTeamIdDistributionRouteImport } from './routes/_app/teams.$teamId.distribution'
import { Route as AppTeamsTeamIdEvaluateRouteImport } from './routes/_app/teams.$teamId.evaluate'
import { Route as AppTeamsTeamIdEvaluationRouteImport } from './routes/_app/teams.$teamId.evaluation'
import { Route as AppTeamsTeamIdReportRouteImport } from './routes/_app/teams.$teamId.report'
import { Route as AppAccountApiAppIdIndexRouteImport } from './routes/_app/account.api.$appId.index'
import { Route as AppAccountApiAppIdApplicantsRouteImport } from './routes/_app/account.api.$appId.applicants'
import { Route as AppAccountApiAppIdCompaniesRouteImport } from './routes/_app/account.api.$appId.companies'
import { Route as AppAccountApiAppIdJobsRouteImport } from './routes/_app/account.api.$appId.jobs'
import { Route as AppAccountApiAppIdPlaygroundRouteImport } from './routes/_app/account.api.$appId.playground'
import { Route as AppAccountApiAppIdSettingsRouteImport } from './routes/_app/account.api.$appId.settings'
import { Route as AppDevResourcesTransitionsOneIndexRouteImport } from './routes/_app/dev-resources.transitions.one.index'
import { Route as AppDevResourcesTransitionsOneItemRouteImport } from './routes/_app/dev-resources.transitions.one.item'
import { Route as AppEmployeesListEmployeeIdReportRouteImport } from './routes/_app/employees._list.$employeeId.report'
import { Route as AppJobsListJobIdIndexRouteImport } from './routes/_app/jobs._list.$jobId.index'
import { Route as AppJobsListJobIdBoardRouteImport } from './routes/_app/jobs._list.$jobId.board'
import { Route as AppJobsListJobIdDistributionRouteImport } from './routes/_app/jobs._list.$jobId.distribution'
import { Route as AppJobsListJobIdReportRouteImport } from './routes/_app/jobs._list.$jobId.report'
import { Route as AppOffersListOfferIdIndexRouteImport } from './routes/_app/offers._list.$offerId.index'
import { Route as AppOffersListOfferIdBoardRouteImport } from './routes/_app/offers._list.$offerId.board'
import { Route as AppOffersListOfferIdDistributionRouteImport } from './routes/_app/offers._list.$offerId.distribution'
import { Route as AppOffersListOfferIdReportRouteImport } from './routes/_app/offers._list.$offerId.report'
import { Route as AppOrgsOrgIdGroupsGroupIdRouteImport } from './routes/_app/orgs.$orgId.groups.$groupId'
import { Route as AppOrgsOrgIdUsersGroupsRouteImport } from './routes/_app/orgs_.$orgId.users.groups'
import { Route as AppAccountApiAppIdApplicantsListRouteImport } from './routes/_app/account.api.$appId.applicants._list'
import { Route as AppAccountApiAppIdCompaniesListRouteImport } from './routes/_app/account.api.$appId.companies._list'
import { Route as AppAccountApiAppIdJobsListRouteImport } from './routes/_app/account.api.$appId.jobs._list'
import { Route as AppDevResourcesTransitionsOneItemIndexRouteImport } from './routes/_app/dev-resources.transitions.one.item.index'
import { Route as AppDevResourcesTransitionsOneItemAlphaRouteImport } from './routes/_app/dev-resources.transitions.one.item.alpha'
import { Route as AppDevResourcesTransitionsOneItemBoardRouteImport } from './routes/_app/dev-resources.transitions.one.item.board'
import { Route as AppDevResourcesTransitionsOneItemDeltaRouteImport } from './routes/_app/dev-resources.transitions.one.item.delta'
import { Route as AppDevResourcesTransitionsOneItemGammaRouteImport } from './routes/_app/dev-resources.transitions.one.item.gamma'
import { Route as AppOrgsOrgIdGroupsGroupIdIndexRouteImport } from './routes/_app/orgs.$orgId.groups.$groupId.index'
import { Route as AppOrgsOrgIdGroupsGroupIdBoardRouteImport } from './routes/_app/orgs.$orgId.groups.$groupId.board'
import { Route as AppOrgsOrgIdGroupsGroupIdDistributionRouteImport } from './routes/_app/orgs.$orgId.groups.$groupId.distribution'
import { Route as AppOrgsOrgIdGroupsGroupIdReportRouteImport } from './routes/_app/orgs.$orgId.groups.$groupId.report'
import { Route as AppOrgsOrgIdUsersGroupsIndexRouteImport } from './routes/_app/orgs_.$orgId.users.groups.index'
import { Route as AppAccountApiAppIdApplicantsListIndexRouteImport } from './routes/_app/account.api.$appId.applicants._list.index'
import { Route as AppAccountApiAppIdCompaniesListIndexRouteImport } from './routes/_app/account.api.$appId.companies._list.index'
import { Route as AppAccountApiAppIdJobsListIndexRouteImport } from './routes/_app/account.api.$appId.jobs._list.index'
import { Route as AppDevResourcesTransitionsOneItemAlphaIndexRouteImport } from './routes/_app/dev-resources.transitions.one.item.alpha.index'
import { Route as AppDevResourcesTransitionsOneItemAlphaXRouteImport } from './routes/_app/dev-resources.transitions.one.item.alpha.x'
import { Route as AppDevResourcesTransitionsOneItemAlphaYRouteImport } from './routes/_app/dev-resources.transitions.one.item.alpha.y'
import { Route as AppDevResourcesTransitionsOneItemDeltaIndexRouteImport } from './routes/_app/dev-resources.transitions.one.item.delta.index'
import { Route as AppDevResourcesTransitionsOneItemDeltaXRouteImport } from './routes/_app/dev-resources.transitions.one.item.delta.x'
import { Route as AppDevResourcesTransitionsOneItemDeltaYRouteImport } from './routes/_app/dev-resources.transitions.one.item.delta.y'
import { Route as AppDevResourcesTransitionsOneItemGammaIndexRouteImport } from './routes/_app/dev-resources.transitions.one.item.gamma.index'
import { Route as AppDevResourcesTransitionsOneItemGammaXRouteImport } from './routes/_app/dev-resources.transitions.one.item.gamma.x'
import { Route as AppDevResourcesTransitionsOneItemGammaYRouteImport } from './routes/_app/dev-resources.transitions.one.item.gamma.y'
import { Route as AppOrgsOrgIdUsersGroupsGroupIdIndexRouteImport } from './routes/_app/orgs_.$orgId.users.groups.$groupId.index'
import { Route as AppOrgsOrgIdUsersGroupsGroupIdDescribeIndexRouteImport } from './routes/_app/orgs_.$orgId.users.groups.$groupId.describe.index'
import { Route as AppOrgsOrgIdUsersGroupsGroupIdDescribeIndicatorStepRouteImport } from './routes/_app/orgs_.$orgId.users.groups.$groupId.describe.$indicator.$step'

const IndexRoute = IndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => rootRouteImport
          })
const AppRouteRoute = AppRouteRouteImport.update({
            id: '/_app',getParentRoute: () => rootRouteImport
          })
const LandingRouteRoute = LandingRouteRouteImport.update({
            id: '/_landing',getParentRoute: () => rootRouteImport
          })
const AppAccountRoute = AppAccountRouteImport.update({
            id: '/account',path: '/account',getParentRoute: () => AppRouteRoute
          })
const AppCheckoutRoute = AppCheckoutRouteImport.update({
            id: '/checkout',path: '/checkout',getParentRoute: () => AppRouteRoute
          })
const AppDevResourcesRoute = AppDevResourcesRouteImport.update({
            id: '/dev-resources',path: '/dev-resources',getParentRoute: () => AppRouteRoute
          })
const AppEmployeesRoute = AppEmployeesRouteImport.update({
            id: '/employees',path: '/employees',getParentRoute: () => AppRouteRoute
          })
const AppJobsRoute = AppJobsRouteImport.update({
            id: '/jobs',path: '/jobs',getParentRoute: () => AppRouteRoute
          })
const AppMarketRoute = AppMarketRouteImport.update({
            id: '/market',path: '/market',getParentRoute: () => AppRouteRoute
          })
const AppOffersRoute = AppOffersRouteImport.update({
            id: '/offers',path: '/offers',getParentRoute: () => AppRouteRoute
          })
const AppOrgsRoute = AppOrgsRouteImport.update({
            id: '/orgs',path: '/orgs',getParentRoute: () => AppRouteRoute
          })
const AppReportRoute = AppReportRouteImport.update({
            id: '/report',path: '/report',getParentRoute: () => AppRouteRoute
          })
const AppTeamsRoute = AppTeamsRouteImport.update({
            id: '/teams',path: '/teams',getParentRoute: () => AppRouteRoute
          })
const LandingCookiesPolicyRoute = LandingCookiesPolicyRouteImport.update({
            id: '/cookies-policy',path: '/cookies-policy',getParentRoute: () => LandingRouteRoute
          })
const LandingDocsRoute = LandingDocsRouteImport.update({
            id: '/docs',path: '/docs',getParentRoute: () => LandingRouteRoute
          })
const LandingPrivacyPolicyRoute = LandingPrivacyPolicyRouteImport.update({
            id: '/privacy-policy',path: '/privacy-policy',getParentRoute: () => LandingRouteRoute
          })
const LandingTermsOfUseRoute = LandingTermsOfUseRouteImport.update({
            id: '/terms-of-use',path: '/terms-of-use',getParentRoute: () => LandingRouteRoute
          })
const AppPublicBeginPasswordResetRoute = AppPublicBeginPasswordResetRouteImport.update({
            id: '/_public/begin-password-reset',path: '/begin-password-reset',getParentRoute: () => AppRouteRoute
          })
const AppPublicLoginRoute = AppPublicLoginRouteImport.update({
            id: '/_public/login',path: '/login',getParentRoute: () => AppRouteRoute
          })
const AppAccountIndexRoute = AppAccountIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => AppAccountRoute
          })
const AppAccountApiRoute = AppAccountApiRouteImport.update({
            id: '/api',path: '/api',getParentRoute: () => AppAccountRoute
          })
const AppAccountBillingRoute = AppAccountBillingRouteImport.update({
            id: '/billing',path: '/billing',getParentRoute: () => AppAccountRoute
          })
const AppBetaGenerateRoute = AppBetaGenerateRouteImport.update({
            id: '/beta/generate',path: '/beta/generate',getParentRoute: () => AppRouteRoute
          })
const AppDevResourcesIndexRoute = AppDevResourcesIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => AppDevResourcesRoute
          })
const AppDevResourcesComponentsRoute = AppDevResourcesComponentsRouteImport.update({
            id: '/components',path: '/components',getParentRoute: () => AppDevResourcesRoute
          })
const AppDevResourcesEmailsRoute = AppDevResourcesEmailsRouteImport.update({
            id: '/emails',path: '/emails',getParentRoute: () => AppDevResourcesRoute
          })
const AppDevResourcesErrorsRoute = AppDevResourcesErrorsRouteImport.update({
            id: '/errors',path: '/errors',getParentRoute: () => AppDevResourcesRoute
          })
const AppDevResourcesTransitionsRoute = AppDevResourcesTransitionsRouteImport.update({
            id: '/transitions',path: '/transitions',getParentRoute: () => AppDevResourcesRoute
          })
const AppEmployeesListRoute = AppEmployeesListRouteImport.update({
            id: '/_list',getParentRoute: () => AppEmployeesRoute
          })
const AppJobsListRoute = AppJobsListRouteImport.update({
            id: '/_list',getParentRoute: () => AppJobsRoute
          })
const AppMarketReportRoute = AppMarketReportRouteImport.update({
            id: '/_report',getParentRoute: () => AppMarketRoute
          })
const AppOffersListRoute = AppOffersListRouteImport.update({
            id: '/_list',getParentRoute: () => AppOffersRoute
          })
const AppOrgsIndexRoute = AppOrgsIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => AppOrgsRoute
          })
const AppRegisterIndexRoute = AppRegisterIndexRouteImport.update({
            id: '/register/',path: '/register/',getParentRoute: () => AppRouteRoute
          })
const AppRegisterApplicantRoute = AppRegisterApplicantRouteImport.update({
            id: '/register/applicant',path: '/register/applicant',getParentRoute: () => AppRouteRoute
          })
const AppRegisterCompanyRoute = AppRegisterCompanyRouteImport.update({
            id: '/register/company',path: '/register/company',getParentRoute: () => AppRouteRoute
          })
const AppReportReportRoute = AppReportReportRouteImport.update({
            id: '/_report',getParentRoute: () => AppReportRoute
          })
const AppTeamsIndexRoute = AppTeamsIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => AppTeamsRoute
          })
const AppTeamsTeamIdRoute = AppTeamsTeamIdRouteImport.update({
            id: '/$teamId',path: '/$teamId',getParentRoute: () => AppTeamsRoute
          })
const AppTestIndexRoute = AppTestIndexRouteImport.update({
            id: '/test/',path: '/test/',getParentRoute: () => AppRouteRoute
          })
const AppTestCompetencesRoute = AppTestCompetencesRouteImport.update({
            id: '/test/competences',path: '/test/competences',getParentRoute: () => AppRouteRoute
          })
const AppTestPersonalityRoute = AppTestPersonalityRouteImport.update({
            id: '/test/personality',path: '/test/personality',getParentRoute: () => AppRouteRoute
          })
const AppTestValuesRoute = AppTestValuesRouteImport.update({
            id: '/test/values',path: '/test/values',getParentRoute: () => AppRouteRoute
          })
const AppPublicEmployeeInvitationTokenRoute = AppPublicEmployeeInvitationTokenRouteImport.update({
            id: '/_public/employee-invitation/$token',path: '/employee-invitation/$token',getParentRoute: () => AppRouteRoute
          })
const AppPublicUpdatePasswordTokenRoute = AppPublicUpdatePasswordTokenRouteImport.update({
            id: '/_public/update-password/$token',path: '/update-password/$token',getParentRoute: () => AppRouteRoute
          })
const AppPublicVerifyEmailTokenRoute = AppPublicVerifyEmailTokenRouteImport.update({
            id: '/_public/verify-email/$token',path: '/verify-email/$token',getParentRoute: () => AppRouteRoute
          })
const AppAccountApiIndexRoute = AppAccountApiIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => AppAccountApiRoute
          })
const AppAccountApiAppIdRoute = AppAccountApiAppIdRouteImport.update({
            id: '/$appId',path: '/$appId',getParentRoute: () => AppAccountApiRoute
          })
const AppDevResourcesTransitionsIndexRoute = AppDevResourcesTransitionsIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => AppDevResourcesTransitionsRoute
          })
const AppDevResourcesTransitionsOneRoute = AppDevResourcesTransitionsOneRouteImport.update({
            id: '/one',path: '/one',getParentRoute: () => AppDevResourcesTransitionsRoute
          })
const AppDevResourcesTransitionsTwoRoute = AppDevResourcesTransitionsTwoRouteImport.update({
            id: '/two',path: '/two',getParentRoute: () => AppDevResourcesTransitionsRoute
          })
const AppEmployeesListIndexRoute = AppEmployeesListIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => AppEmployeesListRoute
          })
const AppEmployeesListEmployeeIdRoute = AppEmployeesListEmployeeIdRouteImport.update({
            id: '/$employeeId',path: '/$employeeId',getParentRoute: () => AppEmployeesListRoute
          })
const AppJobsListIndexRoute = AppJobsListIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => AppJobsListRoute
          })
const AppJobsListJobIdRoute = AppJobsListJobIdRouteImport.update({
            id: '/$jobId',path: '/$jobId',getParentRoute: () => AppJobsListRoute
          })
const AppMarketReportIndexRoute = AppMarketReportIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => AppMarketReportRoute
          })
const AppOffersListIndexRoute = AppOffersListIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => AppOffersListRoute
          })
const AppOffersListOfferIdRoute = AppOffersListOfferIdRouteImport.update({
            id: '/$offerId',path: '/$offerId',getParentRoute: () => AppOffersListRoute
          })
const AppOrgsOrgIdIndexRoute = AppOrgsOrgIdIndexRouteImport.update({
            id: '/$orgId/',path: '/$orgId/',getParentRoute: () => AppOrgsRoute
          })
const AppReportReportIndexRoute = AppReportReportIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => AppReportReportRoute
          })
const AppTeamsTeamIdIndexRoute = AppTeamsTeamIdIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => AppTeamsTeamIdRoute
          })
const AppTeamsTeamIdBoardRoute = AppTeamsTeamIdBoardRouteImport.update({
            id: '/board',path: '/board',getParentRoute: () => AppTeamsTeamIdRoute
          })
const AppTeamsTeamIdDistributionRoute = AppTeamsTeamIdDistributionRouteImport.update({
            id: '/distribution',path: '/distribution',getParentRoute: () => AppTeamsTeamIdRoute
          })
const AppTeamsTeamIdEvaluateRoute = AppTeamsTeamIdEvaluateRouteImport.update({
            id: '/evaluate',path: '/evaluate',getParentRoute: () => AppTeamsTeamIdRoute
          })
const AppTeamsTeamIdEvaluationRoute = AppTeamsTeamIdEvaluationRouteImport.update({
            id: '/evaluation',path: '/evaluation',getParentRoute: () => AppTeamsTeamIdRoute
          })
const AppTeamsTeamIdReportRoute = AppTeamsTeamIdReportRouteImport.update({
            id: '/report',path: '/report',getParentRoute: () => AppTeamsTeamIdRoute
          })
const AppAccountApiAppIdIndexRoute = AppAccountApiAppIdIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => AppAccountApiAppIdRoute
          })
const AppAccountApiAppIdApplicantsRoute = AppAccountApiAppIdApplicantsRouteImport.update({
            id: '/applicants',path: '/applicants',getParentRoute: () => AppAccountApiAppIdRoute
          })
const AppAccountApiAppIdCompaniesRoute = AppAccountApiAppIdCompaniesRouteImport.update({
            id: '/companies',path: '/companies',getParentRoute: () => AppAccountApiAppIdRoute
          })
const AppAccountApiAppIdJobsRoute = AppAccountApiAppIdJobsRouteImport.update({
            id: '/jobs',path: '/jobs',getParentRoute: () => AppAccountApiAppIdRoute
          })
const AppAccountApiAppIdPlaygroundRoute = AppAccountApiAppIdPlaygroundRouteImport.update({
            id: '/playground',path: '/playground',getParentRoute: () => AppAccountApiAppIdRoute
          })
const AppAccountApiAppIdSettingsRoute = AppAccountApiAppIdSettingsRouteImport.update({
            id: '/settings',path: '/settings',getParentRoute: () => AppAccountApiAppIdRoute
          })
const AppDevResourcesTransitionsOneIndexRoute = AppDevResourcesTransitionsOneIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => AppDevResourcesTransitionsOneRoute
          })
const AppDevResourcesTransitionsOneItemRoute = AppDevResourcesTransitionsOneItemRouteImport.update({
            id: '/item',path: '/item',getParentRoute: () => AppDevResourcesTransitionsOneRoute
          })
const AppEmployeesListEmployeeIdReportRoute = AppEmployeesListEmployeeIdReportRouteImport.update({
            id: '/report',path: '/report',getParentRoute: () => AppEmployeesListEmployeeIdRoute
          })
const AppJobsListJobIdIndexRoute = AppJobsListJobIdIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => AppJobsListJobIdRoute
          })
const AppJobsListJobIdBoardRoute = AppJobsListJobIdBoardRouteImport.update({
            id: '/board',path: '/board',getParentRoute: () => AppJobsListJobIdRoute
          })
const AppJobsListJobIdDistributionRoute = AppJobsListJobIdDistributionRouteImport.update({
            id: '/distribution',path: '/distribution',getParentRoute: () => AppJobsListJobIdRoute
          })
const AppJobsListJobIdReportRoute = AppJobsListJobIdReportRouteImport.update({
            id: '/report',path: '/report',getParentRoute: () => AppJobsListJobIdRoute
          })
const AppOffersListOfferIdIndexRoute = AppOffersListOfferIdIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => AppOffersListOfferIdRoute
          })
const AppOffersListOfferIdBoardRoute = AppOffersListOfferIdBoardRouteImport.update({
            id: '/board',path: '/board',getParentRoute: () => AppOffersListOfferIdRoute
          })
const AppOffersListOfferIdDistributionRoute = AppOffersListOfferIdDistributionRouteImport.update({
            id: '/distribution',path: '/distribution',getParentRoute: () => AppOffersListOfferIdRoute
          })
const AppOffersListOfferIdReportRoute = AppOffersListOfferIdReportRouteImport.update({
            id: '/report',path: '/report',getParentRoute: () => AppOffersListOfferIdRoute
          })
const AppOrgsOrgIdGroupsGroupIdRoute = AppOrgsOrgIdGroupsGroupIdRouteImport.update({
            id: '/$orgId/groups/$groupId',path: '/$orgId/groups/$groupId',getParentRoute: () => AppOrgsRoute
          })
const AppOrgsOrgIdUsersGroupsRoute = AppOrgsOrgIdUsersGroupsRouteImport.update({
            id: '/orgs_/$orgId/users/groups',path: '/orgs/$orgId/users/groups',getParentRoute: () => AppRouteRoute
          })
const AppAccountApiAppIdApplicantsListRoute = AppAccountApiAppIdApplicantsListRouteImport.update({
            id: '/_list',getParentRoute: () => AppAccountApiAppIdApplicantsRoute
          })
const AppAccountApiAppIdCompaniesListRoute = AppAccountApiAppIdCompaniesListRouteImport.update({
            id: '/_list',getParentRoute: () => AppAccountApiAppIdCompaniesRoute
          })
const AppAccountApiAppIdJobsListRoute = AppAccountApiAppIdJobsListRouteImport.update({
            id: '/_list',getParentRoute: () => AppAccountApiAppIdJobsRoute
          })
const AppDevResourcesTransitionsOneItemIndexRoute = AppDevResourcesTransitionsOneItemIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => AppDevResourcesTransitionsOneItemRoute
          })
const AppDevResourcesTransitionsOneItemAlphaRoute = AppDevResourcesTransitionsOneItemAlphaRouteImport.update({
            id: '/alpha',path: '/alpha',getParentRoute: () => AppDevResourcesTransitionsOneItemRoute
          })
const AppDevResourcesTransitionsOneItemBoardRoute = AppDevResourcesTransitionsOneItemBoardRouteImport.update({
            id: '/board',path: '/board',getParentRoute: () => AppDevResourcesTransitionsOneItemRoute
          })
const AppDevResourcesTransitionsOneItemDeltaRoute = AppDevResourcesTransitionsOneItemDeltaRouteImport.update({
            id: '/delta',path: '/delta',getParentRoute: () => AppDevResourcesTransitionsOneItemRoute
          })
const AppDevResourcesTransitionsOneItemGammaRoute = AppDevResourcesTransitionsOneItemGammaRouteImport.update({
            id: '/gamma',path: '/gamma',getParentRoute: () => AppDevResourcesTransitionsOneItemRoute
          })
const AppOrgsOrgIdGroupsGroupIdIndexRoute = AppOrgsOrgIdGroupsGroupIdIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => AppOrgsOrgIdGroupsGroupIdRoute
          })
const AppOrgsOrgIdGroupsGroupIdBoardRoute = AppOrgsOrgIdGroupsGroupIdBoardRouteImport.update({
            id: '/board',path: '/board',getParentRoute: () => AppOrgsOrgIdGroupsGroupIdRoute
          })
const AppOrgsOrgIdGroupsGroupIdDistributionRoute = AppOrgsOrgIdGroupsGroupIdDistributionRouteImport.update({
            id: '/distribution',path: '/distribution',getParentRoute: () => AppOrgsOrgIdGroupsGroupIdRoute
          })
const AppOrgsOrgIdGroupsGroupIdReportRoute = AppOrgsOrgIdGroupsGroupIdReportRouteImport.update({
            id: '/report',path: '/report',getParentRoute: () => AppOrgsOrgIdGroupsGroupIdRoute
          })
const AppOrgsOrgIdUsersGroupsIndexRoute = AppOrgsOrgIdUsersGroupsIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => AppOrgsOrgIdUsersGroupsRoute
          })
const AppAccountApiAppIdApplicantsListIndexRoute = AppAccountApiAppIdApplicantsListIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => AppAccountApiAppIdApplicantsListRoute
          })
const AppAccountApiAppIdCompaniesListIndexRoute = AppAccountApiAppIdCompaniesListIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => AppAccountApiAppIdCompaniesListRoute
          })
const AppAccountApiAppIdJobsListIndexRoute = AppAccountApiAppIdJobsListIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => AppAccountApiAppIdJobsListRoute
          })
const AppDevResourcesTransitionsOneItemAlphaIndexRoute = AppDevResourcesTransitionsOneItemAlphaIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => AppDevResourcesTransitionsOneItemAlphaRoute
          })
const AppDevResourcesTransitionsOneItemAlphaXRoute = AppDevResourcesTransitionsOneItemAlphaXRouteImport.update({
            id: '/x',path: '/x',getParentRoute: () => AppDevResourcesTransitionsOneItemAlphaRoute
          })
const AppDevResourcesTransitionsOneItemAlphaYRoute = AppDevResourcesTransitionsOneItemAlphaYRouteImport.update({
            id: '/y',path: '/y',getParentRoute: () => AppDevResourcesTransitionsOneItemAlphaRoute
          })
const AppDevResourcesTransitionsOneItemDeltaIndexRoute = AppDevResourcesTransitionsOneItemDeltaIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => AppDevResourcesTransitionsOneItemDeltaRoute
          })
const AppDevResourcesTransitionsOneItemDeltaXRoute = AppDevResourcesTransitionsOneItemDeltaXRouteImport.update({
            id: '/x',path: '/x',getParentRoute: () => AppDevResourcesTransitionsOneItemDeltaRoute
          })
const AppDevResourcesTransitionsOneItemDeltaYRoute = AppDevResourcesTransitionsOneItemDeltaYRouteImport.update({
            id: '/y',path: '/y',getParentRoute: () => AppDevResourcesTransitionsOneItemDeltaRoute
          })
const AppDevResourcesTransitionsOneItemGammaIndexRoute = AppDevResourcesTransitionsOneItemGammaIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => AppDevResourcesTransitionsOneItemGammaRoute
          })
const AppDevResourcesTransitionsOneItemGammaXRoute = AppDevResourcesTransitionsOneItemGammaXRouteImport.update({
            id: '/x',path: '/x',getParentRoute: () => AppDevResourcesTransitionsOneItemGammaRoute
          })
const AppDevResourcesTransitionsOneItemGammaYRoute = AppDevResourcesTransitionsOneItemGammaYRouteImport.update({
            id: '/y',path: '/y',getParentRoute: () => AppDevResourcesTransitionsOneItemGammaRoute
          })
const AppOrgsOrgIdUsersGroupsGroupIdIndexRoute = AppOrgsOrgIdUsersGroupsGroupIdIndexRouteImport.update({
            id: '/$groupId/',path: '/$groupId/',getParentRoute: () => AppOrgsOrgIdUsersGroupsRoute
          })
const AppOrgsOrgIdUsersGroupsGroupIdDescribeIndexRoute = AppOrgsOrgIdUsersGroupsGroupIdDescribeIndexRouteImport.update({
            id: '/$groupId/describe/',path: '/$groupId/describe/',getParentRoute: () => AppOrgsOrgIdUsersGroupsRoute
          })
const AppOrgsOrgIdUsersGroupsGroupIdDescribeIndicatorStepRoute = AppOrgsOrgIdUsersGroupsGroupIdDescribeIndicatorStepRouteImport.update({
            id: '/$groupId/describe/$indicator/$step',path: '/$groupId/describe/$indicator/$step',getParentRoute: () => AppOrgsOrgIdUsersGroupsRoute
          })





const AppAccountApiAppIdApplicantsListRouteChildren = {
  AppAccountApiAppIdApplicantsListIndexRoute: AppAccountApiAppIdApplicantsListIndexRoute
}

const AppAccountApiAppIdApplicantsListRouteWithChildren = AppAccountApiAppIdApplicantsListRoute._addFileChildren(AppAccountApiAppIdApplicantsListRouteChildren)



const AppAccountApiAppIdApplicantsRouteChildren = {
  AppAccountApiAppIdApplicantsListRoute: AppAccountApiAppIdApplicantsListRouteWithChildren
}

const AppAccountApiAppIdApplicantsRouteWithChildren = AppAccountApiAppIdApplicantsRoute._addFileChildren(AppAccountApiAppIdApplicantsRouteChildren)




const AppAccountApiAppIdCompaniesListRouteChildren = {
  AppAccountApiAppIdCompaniesListIndexRoute: AppAccountApiAppIdCompaniesListIndexRoute
}

const AppAccountApiAppIdCompaniesListRouteWithChildren = AppAccountApiAppIdCompaniesListRoute._addFileChildren(AppAccountApiAppIdCompaniesListRouteChildren)



const AppAccountApiAppIdCompaniesRouteChildren = {
  AppAccountApiAppIdCompaniesListRoute: AppAccountApiAppIdCompaniesListRouteWithChildren
}

const AppAccountApiAppIdCompaniesRouteWithChildren = AppAccountApiAppIdCompaniesRoute._addFileChildren(AppAccountApiAppIdCompaniesRouteChildren)




const AppAccountApiAppIdJobsListRouteChildren = {
  AppAccountApiAppIdJobsListIndexRoute: AppAccountApiAppIdJobsListIndexRoute
}

const AppAccountApiAppIdJobsListRouteWithChildren = AppAccountApiAppIdJobsListRoute._addFileChildren(AppAccountApiAppIdJobsListRouteChildren)



const AppAccountApiAppIdJobsRouteChildren = {
  AppAccountApiAppIdJobsListRoute: AppAccountApiAppIdJobsListRouteWithChildren
}

const AppAccountApiAppIdJobsRouteWithChildren = AppAccountApiAppIdJobsRoute._addFileChildren(AppAccountApiAppIdJobsRouteChildren)



const AppAccountApiAppIdRouteChildren = {
  AppAccountApiAppIdApplicantsRoute: AppAccountApiAppIdApplicantsRouteWithChildren,AppAccountApiAppIdCompaniesRoute: AppAccountApiAppIdCompaniesRouteWithChildren,AppAccountApiAppIdJobsRoute: AppAccountApiAppIdJobsRouteWithChildren,AppAccountApiAppIdPlaygroundRoute: AppAccountApiAppIdPlaygroundRoute,AppAccountApiAppIdSettingsRoute: AppAccountApiAppIdSettingsRoute,AppAccountApiAppIdIndexRoute: AppAccountApiAppIdIndexRoute
}

const AppAccountApiAppIdRouteWithChildren = AppAccountApiAppIdRoute._addFileChildren(AppAccountApiAppIdRouteChildren)



const AppAccountApiRouteChildren = {
  AppAccountApiAppIdRoute: AppAccountApiAppIdRouteWithChildren,AppAccountApiIndexRoute: AppAccountApiIndexRoute
}

const AppAccountApiRouteWithChildren = AppAccountApiRoute._addFileChildren(AppAccountApiRouteChildren)



const AppAccountRouteChildren = {
  AppAccountApiRoute: AppAccountApiRouteWithChildren,AppAccountBillingRoute: AppAccountBillingRoute,AppAccountIndexRoute: AppAccountIndexRoute
}

const AppAccountRouteWithChildren = AppAccountRoute._addFileChildren(AppAccountRouteChildren)




const AppDevResourcesTransitionsOneItemAlphaRouteChildren = {
  AppDevResourcesTransitionsOneItemAlphaXRoute: AppDevResourcesTransitionsOneItemAlphaXRoute,AppDevResourcesTransitionsOneItemAlphaYRoute: AppDevResourcesTransitionsOneItemAlphaYRoute,AppDevResourcesTransitionsOneItemAlphaIndexRoute: AppDevResourcesTransitionsOneItemAlphaIndexRoute
}

const AppDevResourcesTransitionsOneItemAlphaRouteWithChildren = AppDevResourcesTransitionsOneItemAlphaRoute._addFileChildren(AppDevResourcesTransitionsOneItemAlphaRouteChildren)




const AppDevResourcesTransitionsOneItemDeltaRouteChildren = {
  AppDevResourcesTransitionsOneItemDeltaXRoute: AppDevResourcesTransitionsOneItemDeltaXRoute,AppDevResourcesTransitionsOneItemDeltaYRoute: AppDevResourcesTransitionsOneItemDeltaYRoute,AppDevResourcesTransitionsOneItemDeltaIndexRoute: AppDevResourcesTransitionsOneItemDeltaIndexRoute
}

const AppDevResourcesTransitionsOneItemDeltaRouteWithChildren = AppDevResourcesTransitionsOneItemDeltaRoute._addFileChildren(AppDevResourcesTransitionsOneItemDeltaRouteChildren)




const AppDevResourcesTransitionsOneItemGammaRouteChildren = {
  AppDevResourcesTransitionsOneItemGammaXRoute: AppDevResourcesTransitionsOneItemGammaXRoute,AppDevResourcesTransitionsOneItemGammaYRoute: AppDevResourcesTransitionsOneItemGammaYRoute,AppDevResourcesTransitionsOneItemGammaIndexRoute: AppDevResourcesTransitionsOneItemGammaIndexRoute
}

const AppDevResourcesTransitionsOneItemGammaRouteWithChildren = AppDevResourcesTransitionsOneItemGammaRoute._addFileChildren(AppDevResourcesTransitionsOneItemGammaRouteChildren)



const AppDevResourcesTransitionsOneItemRouteChildren = {
  AppDevResourcesTransitionsOneItemAlphaRoute: AppDevResourcesTransitionsOneItemAlphaRouteWithChildren,AppDevResourcesTransitionsOneItemBoardRoute: AppDevResourcesTransitionsOneItemBoardRoute,AppDevResourcesTransitionsOneItemDeltaRoute: AppDevResourcesTransitionsOneItemDeltaRouteWithChildren,AppDevResourcesTransitionsOneItemGammaRoute: AppDevResourcesTransitionsOneItemGammaRouteWithChildren,AppDevResourcesTransitionsOneItemIndexRoute: AppDevResourcesTransitionsOneItemIndexRoute
}

const AppDevResourcesTransitionsOneItemRouteWithChildren = AppDevResourcesTransitionsOneItemRoute._addFileChildren(AppDevResourcesTransitionsOneItemRouteChildren)



const AppDevResourcesTransitionsOneRouteChildren = {
  AppDevResourcesTransitionsOneItemRoute: AppDevResourcesTransitionsOneItemRouteWithChildren,AppDevResourcesTransitionsOneIndexRoute: AppDevResourcesTransitionsOneIndexRoute
}

const AppDevResourcesTransitionsOneRouteWithChildren = AppDevResourcesTransitionsOneRoute._addFileChildren(AppDevResourcesTransitionsOneRouteChildren)



const AppDevResourcesTransitionsRouteChildren = {
  AppDevResourcesTransitionsOneRoute: AppDevResourcesTransitionsOneRouteWithChildren,AppDevResourcesTransitionsTwoRoute: AppDevResourcesTransitionsTwoRoute,AppDevResourcesTransitionsIndexRoute: AppDevResourcesTransitionsIndexRoute
}

const AppDevResourcesTransitionsRouteWithChildren = AppDevResourcesTransitionsRoute._addFileChildren(AppDevResourcesTransitionsRouteChildren)



const AppDevResourcesRouteChildren = {
  AppDevResourcesComponentsRoute: AppDevResourcesComponentsRoute,AppDevResourcesEmailsRoute: AppDevResourcesEmailsRoute,AppDevResourcesErrorsRoute: AppDevResourcesErrorsRoute,AppDevResourcesTransitionsRoute: AppDevResourcesTransitionsRouteWithChildren,AppDevResourcesIndexRoute: AppDevResourcesIndexRoute
}

const AppDevResourcesRouteWithChildren = AppDevResourcesRoute._addFileChildren(AppDevResourcesRouteChildren)




const AppEmployeesListEmployeeIdRouteChildren = {
  AppEmployeesListEmployeeIdReportRoute: AppEmployeesListEmployeeIdReportRoute
}

const AppEmployeesListEmployeeIdRouteWithChildren = AppEmployeesListEmployeeIdRoute._addFileChildren(AppEmployeesListEmployeeIdRouteChildren)



const AppEmployeesListRouteChildren = {
  AppEmployeesListEmployeeIdRoute: AppEmployeesListEmployeeIdRouteWithChildren,AppEmployeesListIndexRoute: AppEmployeesListIndexRoute
}

const AppEmployeesListRouteWithChildren = AppEmployeesListRoute._addFileChildren(AppEmployeesListRouteChildren)



const AppEmployeesRouteChildren = {
  AppEmployeesListRoute: AppEmployeesListRouteWithChildren
}

const AppEmployeesRouteWithChildren = AppEmployeesRoute._addFileChildren(AppEmployeesRouteChildren)




const AppJobsListJobIdRouteChildren = {
  AppJobsListJobIdBoardRoute: AppJobsListJobIdBoardRoute,AppJobsListJobIdDistributionRoute: AppJobsListJobIdDistributionRoute,AppJobsListJobIdReportRoute: AppJobsListJobIdReportRoute,AppJobsListJobIdIndexRoute: AppJobsListJobIdIndexRoute
}

const AppJobsListJobIdRouteWithChildren = AppJobsListJobIdRoute._addFileChildren(AppJobsListJobIdRouteChildren)



const AppJobsListRouteChildren = {
  AppJobsListJobIdRoute: AppJobsListJobIdRouteWithChildren,AppJobsListIndexRoute: AppJobsListIndexRoute
}

const AppJobsListRouteWithChildren = AppJobsListRoute._addFileChildren(AppJobsListRouteChildren)



const AppJobsRouteChildren = {
  AppJobsListRoute: AppJobsListRouteWithChildren
}

const AppJobsRouteWithChildren = AppJobsRoute._addFileChildren(AppJobsRouteChildren)




const AppMarketReportRouteChildren = {
  AppMarketReportIndexRoute: AppMarketReportIndexRoute
}

const AppMarketReportRouteWithChildren = AppMarketReportRoute._addFileChildren(AppMarketReportRouteChildren)



const AppMarketRouteChildren = {
  AppMarketReportRoute: AppMarketReportRouteWithChildren
}

const AppMarketRouteWithChildren = AppMarketRoute._addFileChildren(AppMarketRouteChildren)




const AppOffersListOfferIdRouteChildren = {
  AppOffersListOfferIdBoardRoute: AppOffersListOfferIdBoardRoute,AppOffersListOfferIdDistributionRoute: AppOffersListOfferIdDistributionRoute,AppOffersListOfferIdReportRoute: AppOffersListOfferIdReportRoute,AppOffersListOfferIdIndexRoute: AppOffersListOfferIdIndexRoute
}

const AppOffersListOfferIdRouteWithChildren = AppOffersListOfferIdRoute._addFileChildren(AppOffersListOfferIdRouteChildren)



const AppOffersListRouteChildren = {
  AppOffersListOfferIdRoute: AppOffersListOfferIdRouteWithChildren,AppOffersListIndexRoute: AppOffersListIndexRoute
}

const AppOffersListRouteWithChildren = AppOffersListRoute._addFileChildren(AppOffersListRouteChildren)



const AppOffersRouteChildren = {
  AppOffersListRoute: AppOffersListRouteWithChildren
}

const AppOffersRouteWithChildren = AppOffersRoute._addFileChildren(AppOffersRouteChildren)




const AppOrgsOrgIdGroupsGroupIdRouteChildren = {
  AppOrgsOrgIdGroupsGroupIdBoardRoute: AppOrgsOrgIdGroupsGroupIdBoardRoute,AppOrgsOrgIdGroupsGroupIdDistributionRoute: AppOrgsOrgIdGroupsGroupIdDistributionRoute,AppOrgsOrgIdGroupsGroupIdReportRoute: AppOrgsOrgIdGroupsGroupIdReportRoute,AppOrgsOrgIdGroupsGroupIdIndexRoute: AppOrgsOrgIdGroupsGroupIdIndexRoute
}

const AppOrgsOrgIdGroupsGroupIdRouteWithChildren = AppOrgsOrgIdGroupsGroupIdRoute._addFileChildren(AppOrgsOrgIdGroupsGroupIdRouteChildren)



const AppOrgsRouteChildren = {
  AppOrgsIndexRoute: AppOrgsIndexRoute,AppOrgsOrgIdIndexRoute: AppOrgsOrgIdIndexRoute,AppOrgsOrgIdGroupsGroupIdRoute: AppOrgsOrgIdGroupsGroupIdRouteWithChildren
}

const AppOrgsRouteWithChildren = AppOrgsRoute._addFileChildren(AppOrgsRouteChildren)




const AppReportReportRouteChildren = {
  AppReportReportIndexRoute: AppReportReportIndexRoute
}

const AppReportReportRouteWithChildren = AppReportReportRoute._addFileChildren(AppReportReportRouteChildren)



const AppReportRouteChildren = {
  AppReportReportRoute: AppReportReportRouteWithChildren
}

const AppReportRouteWithChildren = AppReportRoute._addFileChildren(AppReportRouteChildren)




const AppTeamsTeamIdRouteChildren = {
  AppTeamsTeamIdBoardRoute: AppTeamsTeamIdBoardRoute,AppTeamsTeamIdDistributionRoute: AppTeamsTeamIdDistributionRoute,AppTeamsTeamIdEvaluateRoute: AppTeamsTeamIdEvaluateRoute,AppTeamsTeamIdEvaluationRoute: AppTeamsTeamIdEvaluationRoute,AppTeamsTeamIdReportRoute: AppTeamsTeamIdReportRoute,AppTeamsTeamIdIndexRoute: AppTeamsTeamIdIndexRoute
}

const AppTeamsTeamIdRouteWithChildren = AppTeamsTeamIdRoute._addFileChildren(AppTeamsTeamIdRouteChildren)



const AppTeamsRouteChildren = {
  AppTeamsTeamIdRoute: AppTeamsTeamIdRouteWithChildren,AppTeamsIndexRoute: AppTeamsIndexRoute
}

const AppTeamsRouteWithChildren = AppTeamsRoute._addFileChildren(AppTeamsRouteChildren)




const AppOrgsOrgIdUsersGroupsRouteChildren = {
  AppOrgsOrgIdUsersGroupsIndexRoute: AppOrgsOrgIdUsersGroupsIndexRoute,AppOrgsOrgIdUsersGroupsGroupIdIndexRoute: AppOrgsOrgIdUsersGroupsGroupIdIndexRoute,AppOrgsOrgIdUsersGroupsGroupIdDescribeIndexRoute: AppOrgsOrgIdUsersGroupsGroupIdDescribeIndexRoute,AppOrgsOrgIdUsersGroupsGroupIdDescribeIndicatorStepRoute: AppOrgsOrgIdUsersGroupsGroupIdDescribeIndicatorStepRoute
}

const AppOrgsOrgIdUsersGroupsRouteWithChildren = AppOrgsOrgIdUsersGroupsRoute._addFileChildren(AppOrgsOrgIdUsersGroupsRouteChildren)



const AppRouteRouteChildren = {
  AppAccountRoute: AppAccountRouteWithChildren,AppCheckoutRoute: AppCheckoutRoute,AppDevResourcesRoute: AppDevResourcesRouteWithChildren,AppEmployeesRoute: AppEmployeesRouteWithChildren,AppJobsRoute: AppJobsRouteWithChildren,AppMarketRoute: AppMarketRouteWithChildren,AppOffersRoute: AppOffersRouteWithChildren,AppOrgsRoute: AppOrgsRouteWithChildren,AppReportRoute: AppReportRouteWithChildren,AppTeamsRoute: AppTeamsRouteWithChildren,AppPublicBeginPasswordResetRoute: AppPublicBeginPasswordResetRoute,AppPublicLoginRoute: AppPublicLoginRoute,AppBetaGenerateRoute: AppBetaGenerateRoute,AppRegisterApplicantRoute: AppRegisterApplicantRoute,AppRegisterCompanyRoute: AppRegisterCompanyRoute,AppTestCompetencesRoute: AppTestCompetencesRoute,AppTestPersonalityRoute: AppTestPersonalityRoute,AppTestValuesRoute: AppTestValuesRoute,AppRegisterIndexRoute: AppRegisterIndexRoute,AppTestIndexRoute: AppTestIndexRoute,AppPublicEmployeeInvitationTokenRoute: AppPublicEmployeeInvitationTokenRoute,AppPublicUpdatePasswordTokenRoute: AppPublicUpdatePasswordTokenRoute,AppPublicVerifyEmailTokenRoute: AppPublicVerifyEmailTokenRoute,AppOrgsOrgIdUsersGroupsRoute: AppOrgsOrgIdUsersGroupsRouteWithChildren
}

const AppRouteRouteWithChildren = AppRouteRoute._addFileChildren(AppRouteRouteChildren)




const LandingRouteRouteChildren = {
  LandingCookiesPolicyRoute: LandingCookiesPolicyRoute,LandingDocsRoute: LandingDocsRoute,LandingPrivacyPolicyRoute: LandingPrivacyPolicyRoute,LandingTermsOfUseRoute: LandingTermsOfUseRoute
}

const LandingRouteRouteWithChildren = LandingRouteRoute._addFileChildren(LandingRouteRouteChildren)

const rootRouteChildren = {
  IndexRoute: IndexRoute,AppRouteRoute: AppRouteRouteWithChildren,LandingRouteRoute: LandingRouteRouteWithChildren
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)